import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../services/api-service";

import { addLookup } from "./lookupSlice";
import { closeUserModal } from "./modalSlice";
import { success } from "./notificationSlice";
import { updatePage } from "./surveySlice";

const initialState = {
  user: { firstName: "", lastName: "", email: "", role: "surveyor" },
  surveyors: {},
  users: {},
};

export const getSurveyors = createAsyncThunk(
  "getSurveyors",
  async ({ pageNum, searchText }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get(
        `get-surveyors?pageNumber=${pageNum}&searchText=${searchText}`
      );
      if (response?.ok) {
        dispatch(
          addLookup({ type: "surveyorId", value: response.data.data.data })
        );
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUsers = createAsyncThunk(
  "getUsers",
  async (
    { pageNum, searchText, pageSize },
    { rejectWithValue, dispatch, getState }
  ) => {
    try {
      const response = await api.get(
        `get-users?pageNumber=${pageNum}&pageSize=${
          pageSize ? pageSize : getState().survey.pageSize
        }&searchText=${searchText}`
      );
      if (response?.ok) {
        dispatch(updatePage(pageNum));
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "getUsers",
  async ({ user, pageNum }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.delete(`delete-user/${user.id}`);
      if (response?.ok) {
        {
          dispatch(getUsers({ pageNum, searchText: "" }));
          dispatch(updatePage(pageNum));
          dispatch(getSurveyors({ pageNum, searchText: "" }));
          return { ...response };
        }
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUser = createAsyncThunk(
  "addUser",
  async (user, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post("add-user", user);
      if (response && response.ok) {
        dispatch(closeUserModal());
        dispatch(success({ message: "User added successfully" }));
        dispatch(getUsers({ pageNum: 1, searchText: "" }));
        dispatch(getSurveyors({ pageNum: 1, searchText: "" }));
        return { ...response };
      } else {
        throw new Error({ ...response });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUser = createAsyncThunk(
  "updateUser",
  async (user, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(`update-user/${user.id}`, user);
      if (response && response.ok) {
        dispatch(closeUserModal());
        dispatch(success({ message: "User updated successfully" }));
        dispatch(getUsers({ pageNum: 1, searchText: "" }));
        return { ...response };
      } else {
        throw new Error({ ...response });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    setUserField: (state, action) => {
      state.user.user[action.payload.field] = action.payload.value;
    },
    setUser: (state, action) => {
      state.user.user = action.payload;
    },
    setSurveyors: (state, action) => {
      state.surveyors = action.payload;
    },
    resetUser: (state) => {
      state.user = initialState;
    },
  },
  extraReducers: (builders) => {
    builders
      .addCase(getSurveyors.fulfilled, (state, actions) => {
        state.surveyors = actions.payload.data?.data;
      })
      .addCase(getUsers.fulfilled, (state, actions) => {
        state.users = actions.payload.data?.data;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setUserField, setUser, resetUser, setSurveyors } =
  userSlice.actions;
export const surveyorSelector = (state) => state.user.surveyors;
export const userSelector = (state) => state.user.user;
export const usersSelector = (state) => state.user.users;

export default userSlice.reducer;
